/* eslint max-len: 0 */
export const messages = {
  panel: {
    title: {
      id: 'healthSummary.Panel.Title',
      defaultMessage: 'Health Information Summary',
    },
    introduction: {
      id: 'healthSummary.Panel.Introduction',
      defaultMessage: 'See a summary of your most recent health information. Download a copy for yourself or send it to a care provider.',
    },
    buttonText: {
      id: 'healthSummary.Panel.ButtonText',
      defaultMessage: 'View My Health Info',
    },
  },
  screenReader: {
    button: {
      id: 'healthSummary.ScreenReader.Button',
      defaultMessage: 'View My Health Info link clicking takes you to Health Summary page',
    },
  },
};
